import throwError from './throwError';

const throw403 = () => throwError(403, 'EACCES');

export default throw403;
